// AuthCallback.jsx
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { initNewToken } from '../../services/apiClient';

import { userService } from '../../services/userService';



function AuthCallback({ onAuthSuccess }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const error = params.get('error');

      if (error) {
          console.error('OAuth error:', error);
          navigate('/login?error=auth_failed');
          return;
      };


      const tokGet = await initNewToken(code);

      if(tokGet?.token) {
          onAuthSuccess(tokGet);
          setTimeout(()=>navigate(userService.firstPage(),  { replace: true }), 500);
      } else {
          navigate('/');
      }

    };

    handleCallback();
  }, [ location ]);

  return <div>Обробка авторизації...</div>;
}

export default AuthCallback;